import { AutocompleteInput } from 'react-admin';
import { useInfiniteAutocomplete } from '../../../hooks/useInfiniteAutocomplete';

export const SubjectsAutoComplete = (props: any) => {

    const {
        choices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('subjects', {
        sort: { field: 'createdAt', order: 'DESC' },
        baseFilter: { deleted: false },
        searchField: 'name',
    });

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'subjectId'}
            fullWidth
            label="Subjects"
            choices={choices}
            optionText="name"
            optionValue="id"
            loading={isLoading}
            setFilter={setSearchText}
            ListboxProps={{ onScroll: handleScroll }}
            debounce={500}
        />
    );
};